import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import OnePageHome from '@/pages/OnePageHome';
import { Toaster } from '@/components/ui/toaster';
import '@/App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<OnePageHome />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
